function ArrowUpRight() {
    return (
      <div className="
      translate-x-0 translate-y-0
      group-hover:opacity-100 group-hover:translate-x-[1px] group-hover:translate-y-[-2px] 
      transition-all duration-300 ease-out">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-up-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 7l-10 10" /><path d="M8 7l9 0l0 9" /></svg>       
      </div>
    )
  }
  
  export default ArrowUpRight;